/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsAjaxCart = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsAjaxCart = $.extend(
        this,
        Shopify.theme.getSectionData($section)
      );

      if (isScreenSizeLarge() || this.cart_action == "drawer") {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == "drawer") {
        this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");

        $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();

          return false;
        });
      } else if (this.cart_action == "mini_cart") {
        this.showMiniCartOnHover();
      }

      $(document).on("click", ".ajax-submit", function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest("form");
        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
        //console.log('added to cart')
        return false;
      });

      $(document).on("click", "[data-ajax-cart-delete]", function (e) {
        e.preventDefault();

        const lineID = $(this).parents("[data-line-item]").data("line-item");
        const lineSelector = lineID;
        let lineItems = document.querySelectorAll(".ajax-cart__product");
        let deleteLineItem = lineItems[lineSelector].dataset.variantId;

        Shopify.theme.jsAjaxCart.removeFromCart(deleteLineItem);
      });

      $(document).on("click", "[data-ajax-cart-close]", function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.hideDrawer();
        Shopify.theme.jsAjaxCart.hideMiniCart();

        return false;
      });

      //Upsell product - add to cart for variants
      $(document).on(
        "click",
        ".cart-upsell-variant-btns .cart-upsell-variant-btn",
        function () {
          $(".cart-upsell-variant-btns .cart-upsell-variant-btn").removeClass(
            "upsell-var-active"
          );
          var upsellVariantId = $(this).attr("data-variant-id");
          var upsellVariantPrice = $(this).attr("data-variant-price");
          $(".ajax-upsell-add-in-cart").attr(
            "data-variant-id",
            upsellVariantId
          );
          $(".ajax-upsell-add-in-cart span").text(upsellVariantPrice);
          $(this).addClass("upsell-var-active");
        }
      );

      $(document).on("click", ".ajax-upsell-add-in-cart", function () {
        var upsellBtnVariantId = $(this).attr("data-variant-id");
        var items = [{ quantity: 1, id: upsellBtnVariantId }];
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: { items: items },
          dataType: "json",
          success: function (cart) {
            Shopify.theme.jsAjaxCart.repopulateCart(cart);
          },
          error: function (XMLHttpRequest, textStatus) {
            var response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;
          },
        });
      });
    },
    //Upsell product - settings are in Customizer > Theme Settings > Cart > Cart upsell
    //HTML/Liquid for upsell product is in cart.ajax.liquid
    showUpsell: function () {
      if ($(".cart-upsell-item").length) {
        // create empty array to catch all variants in cart
        var cartUpsellVariantsInCart = [];
        // create empty array to catch all variants in upsell product
        var cartUpsellVariants = [];
        // get cart upsell item id -> set in Settings
        var cartUpsellId = $(".cart-upsell-item").attr("data-product-id");

        // push to array all variants from upsell product already in cart
        $(".ajax-cart__product").each(function () {
          var upsellMainProduct = $(this).attr("data-product-id");
          var upsellMainAllocation = $(this).attr("data-variant-allocation");
          var upsellVariantPrice = parseInt(
            $(this).attr("data-variant-price-full")
          );
          if (upsellMainProduct == cartUpsellId && upsellMainAllocation == "") {
            cartUpsellVariantsInCart.push(upsellVariantPrice);
          }
        });

        //cart for console
        // $.getJSON('/cart.js', function(cart) {
        //   console.log('cart')
        //   console.log(cart.items);
        // });

        //get the Highest price from upsell variants (so we can remove all variants with lower prices)
        var cartUpsellVariantsInCartSort = cartUpsellVariantsInCart.sort();
        var cartUpsellVariantsInCartHighest =
          cartUpsellVariantsInCartSort.reverse()[0];

        //push to array all variants from upsell product
        $(".cart-upsell-variant-btn").each(function () {
          var upsellVariantItem = parseInt(
            $(this).attr("data-variant-price-full")
          );
          cartUpsellVariants.push(upsellVariantItem);
        });

        //sort variant prices
        var cartUpsellVariantsSort = cartUpsellVariants.sort();

        //get all variants (based on prices) that should be shown - show add to cart buttons
        var cartUpsellLeaveVariants = cartUpsellVariantsSort.filter(function (
          x
        ) {
          return x > cartUpsellVariantsInCartHighest;
        });
        //get all variants (based on prices) that should be hidden- hide add to cart buttons
        var cartUpsellRemoveVariants = cartUpsellVariantsSort.filter(function (
          x
        ) {
          return x <= cartUpsellVariantsInCartHighest;
        });
        //hide buttons for variants with prices below largest price already in cart
        $.each(cartUpsellRemoveVariants, function (index, item) {
          $('.cart-upsell-variant-btn[data-variant-price-full="' + item + '"]')
            .hide()
            .addClass("cart-upsell-variant-removed")
            .removeClass("cart-upsell-visible");
        });

        //wait 500ms to check everything and then show or hide upsell and preselect the first available variant
        setTimeout(function () {
          //show/hide entire upsell product
          if (
            cartUpsellVariantsInCart.length > 0 &&
            cartUpsellLeaveVariants.length != 0
          ) {
            $(".cart-upsell-item")
              .removeClass("cart-upsell-hide")
              .addClass("cart-upsell-show");
            //console.log('show!')
          } else {
            $(".cart-upsell-item")
              .removeClass("cart-upsell-show")
              .addClass("cart-upsell-hide");
          }

          //preselect add to cart upsell variant button on page load
          $(".cart-upsell-visible").each(function (index, element) {
            if ($(this).is(".cart-upsell-visible")) {
              $(element).addClass("upsell-var-active");
              var upsellVariantId = $(element).attr("data-variant-id");
              var upsellVariantPrice = $(element).attr("data-variant-price");
              $(".ajax-upsell-add-in-cart").attr(
                "data-variant-id",
                upsellVariantId
              );
              $(".ajax-upsell-add-in-cart span").text(upsellVariantPrice);
              return false;
            }
          });
        }, 500);
      }
    },
    showMiniCartOnHover: function () {
      const $el = $("[data-ajax-cart-trigger]");

      $el.hover(
        function () {
          if (
            Shopify.theme_settings.header_layout == "centered" &&
            $(".header-sticky-wrapper").hasClass("is-sticky")
          ) {
            $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
              "show-mini-cart"
            );
          } else {
            $el.addClass("show-mini-cart");
          }
        },
        function () {
          $el.removeClass("show-mini-cart");
        }
      );
    },
    hideMiniCart: function () {
      if (this.cart_action != "mini_cart") return false;
      const $el = $("[data-ajax-cart-close]").parents(
        "[data-ajax-cart-trigger]"
      );
      $el.removeClass("show-mini-cart");
    },
    toggleMiniCart: function () {
      const $el = $(".mobile-header [data-ajax-cart-trigger]");

      // Removes url to the cart page so user is not redirected
      $el.attr("href", "#");

      $el.off("touchstart").on("touchstart", function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest("[data-ajax-cart-mini_cart]")) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass("show-mini-cart");
      });
    },
    showDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.addClass("is-visible");
      $(".ajax-cart__overlay").addClass("is-visible");
    },
    hideDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.removeClass("is-visible");
      $(".ajax-cart__overlay").removeClass("is-visible");
    },
    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + lineID,
        dataType: "json",
        success: function (cart) {
          Shopify.theme.jsAjaxCart.repopulateCart(cart);
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
        },
      });
    },
    initializeAjaxCart: function () {
      Shopify.theme.asyncView
        .load(
          Shopify.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          $("[data-ajax-cart-content]").html(html.content);

          // Converting the currencies
          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }
        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();

      Shopify.theme.asyncView
        .load(
          Shopify.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          $(".mobile-header [data-ajax-cart-content]").html(html.content);
        })
        .fail(() => {
          // some error handling
        });
    },
    updateProductInCart: function ($addToCartBtn) {
      let $el = $("[data-ajax-cart-trigger]");

      $addToCartBtn.find(".checkmark").addClass("checkmark-active");

      function addedToCart() {
        if (!isScreenSizeLarge()) {
          $el = $(".mobile-header [data-ajax-cart-trigger]");
          Shopify.theme.scrollToTop($el);
        } else {
          $el = $("[data-ajax-cart-trigger]");
        }

        $el.addClass("show-mini-cart");

        $addToCartBtn.find("span, i").removeClass("fadeInDown");
      }

      window.setTimeout(function () {
        $addToCartBtn.removeAttr("disabled").removeClass("disabled");

        $addToCartBtn.find(".checkmark").removeClass("checkmark-active");

        $addToCartBtn
          .find(".text, .icon, i")
          .removeClass("zoomOut")
          .addClass("fadeInDown");

        $addToCartBtn.on(
          "webkitAnimationEnd oanimationend msAnimationEnd animationend",
          addedToCart
        );
      }, 1000);

      Shopify.theme.jsAjaxCart.showDrawer();
      Shopify.theme.jsAjaxCart.updateView();

      if (Shopify.theme.jsCart) {
        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          dataType: "html",
          url: "/cart",
          success: function (html) {
            const cartForm = $(html).find(".cart__form");
            $(".cart__form").replaceWith(cartForm);
          },
        });
      }
    },
    addToCart: function ($addToCartForm) {
      const self = this;
      const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

        $(".warning").remove();

        $addToCartForm
          .addClass("shopify-product-form--unselected-error")
          .find(".cart-warning")
          .html(cartWarning);

        $addToCartBtn.removeAttr("disabled").removeClass("disabled");

        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

        $addToCartBtn
          .find(".btn-pricing")
          .removeClass("zoomOut")
          .addClass("zoomIn");

        $addToCartBtn
          .find("span:not(.icon), i")
          .text($addToCartBtn.data("label"))
          .removeClass("zoomOut")
          .addClass("zoomIn");
      } else {
        $.ajax({
          url: "/cart/add.js",
          dataType: "json",
          cache: false,
          type: "post",
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn.attr("disabled", "disabled").addClass("disabled");

            $addToCartBtn
              .find("span, i")
              .removeClass("fadeInDown")
              .addClass("animated zoomOut");
          },
          success: function (product) {
            console.log(product)
            self.updateProductInCart($addToCartBtn);
            if (
              window.announcement_popup &&
              window.announcement_popup.enable &&
              window.announcement_popup.required_products.length &&
              window.announcement_popup.free_products.length
            ) {
              window.announcement_popup._onCartAddItem();
            }
          },
          error: function (XMLHttpRequest) {
            let response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace(
              "All 1 ",
              "All "
            )}</p>`;

            $(".warning").remove();

            $addToCartForm.find(".cart-warning").html(cartWarning);

            $addToCartBtn.removeAttr("disabled").removeClass("disabled");

            $addToCartBtn
              .find(".icon")
              .removeClass("zoomOut")
              .addClass("zoomIn");

            $addToCartBtn
              .find("span:not(.icon), i")
              .text($addToCartBtn.data("label"))
              .removeClass("zoomOut")
              .addClass("zoomIn");
          },
        });
      }
    },
    generateLineItemHTML: function (item, lineNumber) {
      let priceCents = 0;
      if(item.properties._originalPriceCents > 0){
        priceCents = item.properties._originalPriceCents * item.quantity;
      }
      return `
    <div class="ajax-cart__product media" 
         data-product-id="${item.product_id}" 
         data-variant-price-full="${item.final_price}" 
         data-variant-allocation="" 
         data-variant-id="${item.variant_id}" 
         data-cart-item="${item.key}" 
         data-line-item="${lineNumber}">
      
      <figure class="ajax-cart__product-image media-left">
        <a href="${item.url}">
          <img src="${item.image}" alt="${item.title} - cart preview">
        </a>
        <div class="ajax-cart__quantity-box product-quantity-box mobile_quantity" data-key="${item.key}" data-line-item-key="${lineNumber}">
          <label class="label is-sr-only" for="quantity">Qty</label>
          <div class="quantity-wrapper field has-addons quantity-style--box is-medium">
            <div class="control minus-control">
              <span class="quantity-minus quantity-element button" data-update-quantity="minus" ${
                item.quantity <= 1 ? "disabled" : ""
              }>
                <span class="icon" data-icon="minus">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <g id="minus"><rect x="5" y="46" width="90" height="8"></rect></g>
                  </svg>
                </span>
              </span>
            </div>
            <div class="control quantity-input-control quantity-input-control--fill">
              <input class="quantity-input quantity-element input" 
                     type="number" 
                     min="1" 
                     size="2" 
                     name="quantity" 
                     value="${item.quantity}" 
                     data-line-id="${lineNumber}">
            </div>
            <div class="control plus-control">
              <span class="quantity-plus quantity-element button" data-update-quantity="plus">
                <span class="icon" data-icon="plus">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g>
                  </svg>
                </span>
              </span>
            </div>
          </div>
        </div>
      </figure>

      <div class="ajax-cart__product-content media-content">
        <div class="ajax-cart__product-title">
          <a href="${item.url}">
            ${item.product_title}
          </a>
        </div>
       ${
          item.selling_plan_allocation?.selling_plan
            ? `<p class="ajax-cart__selling-plan-name">${item.selling_plan_allocation.selling_plan.name}</p>`
            : ""
        }
        <div class="ajax-cart__product-variant" data-variant-id="${item.variant_id}">
          ${item.variant_title ? item.variant_title : ""}             
        </div>
        <div class="ajax-cart__price price">
          <span class="money sale">${Shopify.formatMoney(
            item.final_line_price
          )}</span>
         <span data-quantity="${item.quantity}" data-value="${item.properties._originalPriceCents ? item.properties._originalPriceCents : item.final_price }" class="money compare-at-price">${item.properties._originalPrice ? Shopify.formatMoney(priceCents) : "" }</span>
        </div>

        <div class="ajax-cart__quantity-box product-quantity-box desktop_quantity" data-key="${item.key}" data-line-item-key="${lineNumber}">
          <label class="label is-sr-only" for="quantity">Qty</label>
          <div class="quantity-wrapper field has-addons quantity-style--box is-medium">
            <div class="control minus-control">
              <span class="quantity-minus quantity-element button" data-update-quantity="minus" ${
                item.quantity <= 1 ? "disabled" : ""
              }>
                <span class="icon" data-icon="minus">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <g id="minus"><rect x="5" y="46" width="90" height="8"></rect></g>
                  </svg>
                </span>
              </span>
            </div>
            <div class="control quantity-input-control quantity-input-control--fill">
              <input class="quantity-input quantity-element input" 
                     type="number" 
                     min="1" 
                     size="2" 
                     name="quantity" 
                     value="${item.quantity}" 
                     data-line-id="${lineNumber}">
            </div>
            <div class="control plus-control">
              <span class="quantity-plus quantity-element button" data-update-quantity="plus">
                <span class="icon" data-icon="plus">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g>
                  </svg>
                </span>
              </span>
            </div>
          </div>
          <div class="ajax-cart-remove">
            <a class="ajax-cart__delete" data-ajax-cart-delete="" data-cart-item-key="${
              item.key
            }" href="/cart/change?line=${lineNumber}&quantity=0" title="Remove">
              <button class="close" aria-label="close">Remove</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  `;
    },
    repopulateCart: function (cart) {
      if (cart.item_count > 0) {
        // Update the cart list and details using the cart object
      console.log("jsAjax repopulateCart")
       
        const cartItemsHtml = cart.items
          .map((item, index) => Shopify.theme.jsAjaxCart.generateLineItemHTML(item, index))
          .join("");
        $(".ajax-cart__list").html(cartItemsHtml);

        var priceInCents = cart.total_price;
        let formattedPrice = Shopify.formatMoney(priceInCents, "${{amount}}");
        let total = document.querySelector(".ajax-cart__subtotal .money");
        total.innerHTML = formattedPrice;
        let oldPrices = document.querySelectorAll(".ajax-cart__price .compare-at-price");
       
        let oldTotal = 0;
        oldPrices.forEach(item => {
          oldTotal += (parseInt(item.dataset.value) * item.dataset.quantity);
         
        });
   
        let savedFormated = oldTotal - priceInCents;
        let totalSaved = Shopify.formatMoney(savedFormated, "${{amount}}");
        let savedElement = document.querySelector(".ajax-cart__savings .money");
          console.log(savedElement, totalSaved, savedFormated)
        savedElement.innerHTML = totalSaved;
        // Show/hide appropriate elements
        $(".ajax-cart__empty-cart-message").addClass("is-hidden");
        $(".ajax-cart__form").removeClass("is-hidden");
        $("[data-ajax-cart-trigger]").addClass("has-cart-count");
        $('[data-bind="itemCount"]').text(cart.item_count);

        // Update the shipping indicator asynchronously
        if ($("[data-fs-threshold]").length) {
          const $parent = $("[data-fs-threshold]");
          const $remainingWrapper = $parent.find(".fs-indicator__remaining");
          const $successWrapper = $parent.find(".fs-indicator__success");
        
          const fsThreshold = $parent.data("fs-threshold");
          const totalPrice = cart.total_price;
        

          if (fsThreshold >= totalPrice) {
            const fsRemaining = fsThreshold - totalPrice;
            const fsRemainingPercent = (totalPrice / fsThreshold) * 100;

            $remainingWrapper
              .find(".bar")
              .css("width", `${fsRemainingPercent}%`);
            $remainingWrapper
              .find('[data-bind="remaining-amount"]')
              .text(Shopify.formatMoney(fsRemaining));

            $remainingWrapper.removeClass("is-hidden");
            $successWrapper.addClass("is-hidden");
          } else {
            $remainingWrapper.addClass("is-hidden");
            $successWrapper.removeClass("is-hidden");
          }
        }
      } else {
        // Handle empty cart view
        $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
        $(".ajax-cart__form").addClass("is-hidden");
        $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
        $('[data-bind="itemCount"]').text(0);
      }
      this.showUpsell();
    },

    updateView: function () {
    
      Shopify.theme.asyncView
        .load(
          Shopify.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          if (options.item_count > 0) {
            //window.announcement_popup.updateFreeItem(true);
            const itemList = $(html.content).find(".ajax-cart__list");
            const cartDetails = $(html.content).find(
              ".ajax-cart__details-wrapper"
            );
            const total_price = options.total_price;

            $(".ajax-cart__list").replaceWith(itemList);
            $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
            $(".ajax-cart__empty-cart-message").addClass("is-hidden");
            $(".ajax-cart__form").removeClass("is-hidden");
            $("[data-ajax-cart-trigger]").addClass("has-cart-count");
            $('[data-bind="itemCount"]').text(options.item_count);

            /* Update shipping indicator asynchronously js */
            if ($("[data-fs-threshold]").length) {
              let $parent = $("[data-fs-threshold]");
              let $remainingWrapper = $parent.find(".fs-indicator__remaining");
              let $successWrapper = $parent.find(".fs-indicator__success");

              let fs_threshold = $("[data-fs-threshold]").data("fs-threshold");
              if (fs_threshold >= total_price) {
                //udpate
                let fs_remaining = fs_threshold - total_price;
                let fs_remaining_percent = (total_price / fs_threshold) * 100;

                $remainingWrapper
                  .find(".bar")
                  .css("width", fs_remaining_percent + "%");
                $remainingWrapper
                  .find('[data-bind="remaining-amount"]')
                  .text(Shopify.formatMoney(fs_remaining));

                $remainingWrapper.removeClass("is-hidden");
                $successWrapper.addClass("is-hidden");
              } else {
                //remove shipping indicator
                $remainingWrapper.addClass("is-hidden");
                $successWrapper.removeClass("is-hidden");
              }
            }
            this.showUpsell();
            //console.log('entire cart done')
          } else {
            $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
            $(".ajax-cart__form").addClass("is-hidden");
            $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
            $('[data-bind="itemCount"]').text("0");
          }

          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }
        })
        .fail(() => {
          // some error handling
        });
    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $(".ajax-submit").off();
      $("[data-ajax-cart-delete]").off();
    },
  };

  /******/
})();
